export interface OrderModel {
  id: string | number;
  orderNumber: string;
  totalAmount: number;
  shippingFee: number;
  orderStatus: OrderStatus;
  paymentStatus: PaymentStatus;
  couponCode: string;
  discountAmount: number;
  phoneNumber: string;
  email: string;
  shipName: string;
  shipPhoneNumber: string;
  name: string;
  address: string;
  districtId: number | string;
  districtName: string;
  provinceId: number | string;
  provinceName: string;
  wardId?: number | string;
  wardName?: string;
  subTotalAmount: number;
  kiotVietId: number;
  customerId: number;
  customerName: string;
  orderItems: OrderItem[];
  creationTime: Date;
  lastModificationTime: Date;
}
export enum OrderStatus{
  Processing,
  Shipping,
  Completed,
  Cancel
}
export enum PaymentStatus{
  Unpaid,
  Paid,
}
export interface OrderItem{
  skuId: number | string;
  orderId: number | string;
  price: number;
  quantity: number;
  skuName: string;
  skuImage: string;
}
export interface SearchOrderRequestModel{
  page:number;
  pageSize: number;
}
export interface AddItemsModel{
  items:AddItemModel[]
}
export interface AddItemModel{
  skuId: number | string;
  quantity: number;
}
